<template>
    <div class="p-2">
        <div class="modal-content-container col-12" v-if="isScheduleVisitComponent">
            <div class="pt-3 px-3">
                <div>
                    <h6><strong>Issues Creating Task</strong></h6>
                </div>
            </div>
            <hr class="mb-2" />
            <div class="px-2">
                <p v-if="!hasError" class="d-flex align-items-center">
                    <i class="h2 fas fa-question-circle tooltip-blue fa-2xl"> </i>
                    <span class="h6 ms-2">
                        There were some issues creating the task. If you would like to continue creating, check "Create
                        Anyway" in each section and click Continue. If you would like to cancel, click Back to to
                        {{ name }} Calendar.
                    </span>
                </p>
                <p v-if="hasError" class="d-flex align-items-center">
                    <i class="h2 fas fa-times text-danger fa-2xl"></i>
                    <span class="h6 ms-2">
                        This task cannot be created because of the following errors. Please review the errors, change
                        the task as needed, and try again.
                    </span>
                </p>

                <div class="validations-box mt-4 overflow-auto">
                    <div v-for="(item, index) in validations" :key="item.title">
                        <div class="single-validation mb-4 pb-2 rounded-top">
                            <div>
                                <button
                                    data-bs-toggle="collapse"
                                    :data-bs-target="'#title-' + index"
                                    :aria-expanded="true"
                                    class="p-2 w-100 text-white border-0 bg-transparent d-flex justify-content-between align-items-center au-target"
                                >
                                    <span> {{ item.title }}</span>
                                    <i class="fa fa-chevron-down"></i>
                                    <i class="fa fa-chevron-right"> </i>
                                </button>
                            </div>
                            <div :id="'title-' + index" class="collapse show bg-white mx-2 pb-2 px-4">
                                <div
                                    class="validtion-des-list"
                                    v-for="text of item.description"
                                    :key="item.title + index"
                                >
                                    <pre class="m-0 pt-3 text-wrap medium-text">{{ text }}</pre>
                                </div>

                                <div
                                    v-if="!hasError"
                                    class="p-2 d-flex align-items-center border rounded mt-3 position-relative"
                                >
                                    <span aria-label="required" class="text-danger h4 position-absolute"> * </span>
                                    <input
                                        @change="validationSelected()"
                                        type="checkbox"
                                        :value="'title' + index"
                                        v-model="validationsAccepted"
                                        :id="'title' + index"
                                    />
                                    <label :for="'title' + index" class="ms-2 au-target mb-0"> Create Anyway </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-0 d-flex pb-2 px-3 justify-content-center">
                    <button
                        v-if="!hasError"
                        type="button"
                        :disabled="!enableContinue"
                        @click="ok()"
                        class="btn btn-xs me-2 btn-outline-primary"
                    >
                        Continue
                    </button>
                    <button @click="cancel()" type="button" class="btn btn-xs btn-primary">
                        {{ isPlanner ? "Cancel" : `Back to ${name} Calendar` }}
                    </button>
                </div>
            </div>
        </div>
        <div class="modal-content-container col-12" v-else>
            <div class="pt-3 px-3">
                <div>
                    <h6>
                        <strong>Issues {{ isRestoreVisitComponent ? "Restoring" : "Rescheduling" }} Task</strong>
                    </h6>
                </div>
            </div>
            <hr class="mb-2" />
            <div class="px-2">
                <p v-if="!hasError" class="d-flex align-items-center">
                    <i class="h2 fas fa-question-circle tooltip-blue fa-2xl"> </i>
                    <span class="h6 ms-2">
                        There were some issues updating the task. If you would like to continue updating, check "{{
                            isRestoreVisitComponent ? "Restore" : "Reschedule"
                        }}
                        Anyway" in each section and click Continue. If you would like to cancel, click Back to
                        {{ name }} Calendar.
                    </span>
                </p>
                <p v-if="hasError" class="d-flex align-items-center">
                    <i class="h2 fas fa-times text-danger fa-2xl"></i>
                    <span class="h6 ms-2">
                        This task cannot be {{ isRestoreVisitComponent ? "restored" : "rescheduled" }} because of the
                        following errors. Please review the errors, change the task as needed, and try again.
                    </span>
                </p>

                <div class="validations-box mt-4 overflow-auto">
                    <div v-for="(item, index) of validations" :key="item.title">
                        <div class="single-validation mb-4 pb-2 rounded-top">
                            <div>
                                <button
                                    data-bs-toggle="collapse"
                                    :data-bs-target="'#title-' + index"
                                    :aria-expanded="true"
                                    class="p-2 w-100 text-white border-0 bg-transparent d-flex justify-content-between align-items-center au-target"
                                >
                                    <span> {{ item.title }}</span>
                                    <i class="fa fa-chevron-down"></i>
                                    <i class="fa fa-chevron-right"> </i>
                                </button>
                            </div>
                            <div :id="'title-' + index" class="collapse show bg-white mx-2 pb-2 px-4">
                                <div
                                    class="validtion-des-list"
                                    v-for="text of item.description"
                                    :key="item.title + index"
                                >
                                    <pre class="m-0 pt-3 medium-text text-wrap">{{ text }}</pre>
                                </div>

                                <div
                                    v-if="!hasError"
                                    class="p-2 d-flex align-items-center border rounded mt-3 position-relative"
                                >
                                    <span aria-label="required" class="text-danger h4 position-absolute"> * </span>
                                    <input
                                        @change="validationSelected()"
                                        type="checkbox"
                                        :value="'title' + index"
                                        v-model="validationsAccepted"
                                        :id="'title' + index"
                                    />
                                    <label :for="'title' + index" class="ms-2 au-target mb-0">
                                        {{ isRestoreVisitComponent ? "Restore" : "Reschedule" }} Anyway
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex py-2 px-3 justify-content-center">
                    <button
                        v-if="!hasError"
                        type="button"
                        :disabled="!enableContinue"
                        @click="ok()"
                        class="btn btn-xs me-2 btn-outline-primary"
                    >
                        Continue
                    </button>
                    <button @click="cancel()" type="button" class="btn btn-xs btn-primary">
                        Back to {{ name }} Calendar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.medium-text {
    font-family: sans-serif;
    font-size: inherit;
    font-weight: 100;
    color: #212529;
}
</style>
<script lang="ts" src="./RescheduleValidation"></script>
